import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalProcessingComponent } from "./modal-processing.component";

@NgModule({
  declarations: [ModalProcessingComponent],
  imports: [CommonModule],
  exports: [ModalProcessingComponent],
})
export class ModalProcessingModule {}
